export function daysBetweenNowAnd(dateString: string): number {

    const start = new Date();
    const target = new Date(dateString);

    const day = 24 * 60 * 60 * 1000;

    const first = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const second = Date.UTC(target.getFullYear(), target.getMonth(), target.getDate());

    const diff = (second - first) / day;

    return Math.max(0, Math.floor(diff));
}
